import { connect } from "react-redux";
import { RootState, RootDispatch } from "lib/redux/root/redux.types";
import { setCurrentFlowAction } from "lib/redux/navigation";
import { updateSlotDetailsForCreate } from "ui/appointment/ducks";
import CreateApptAvailableSlotsPage from "./CreateApptAvailableSlotsPage";
import { fetchDocumentForAllTypes } from "ui/appointment/ducks/thunks";
import { CREATE_APPOINTMENT_SLOT_MSG_KEY } from "api/shared/GetDocumentByType/getDocumentByType.mapper";

const mapStateToProps = (state: RootState) => {
  return {
    isSameDayBooking: state.appointments.appointmentMeta.isSameDayBooking,
    location: state.appointments.create?.selectedInstitution || "",
    service: state.appointments.create?.selectedService || "",
    lastVisitDatetime: state.appointments.create?.lastVisitDateTime,
    isUrti: state.appointments.create?.isUrti,
    appointmentType: state.appointments.appointmentMeta.appointmentType,
    isLoadingSlotAndPreConsultMsg: state.appointments.documentByType.isLoading,
    slotMsg:
      state.appointments.documentByType.documentByTypeMap[
        CREATE_APPOINTMENT_SLOT_MSG_KEY
      ],
  };
};

const mapDispatchToProps = (dispatch: RootDispatch) => {
  return {
    onLoad: () => {
      dispatch(setCurrentFlowAction("APPOINTMENT_CREATE"));
    },
    onSelect: (slotId: string, slotDateTime: string | null) => {
      dispatch(updateSlotDetailsForCreate({ slotId, slotDateTime }));
    },
    fetchSlotAndPreConsultMsg: () => {
      dispatch(fetchDocumentForAllTypes());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateApptAvailableSlotsPage);
